'use client';
import { ComponentProps } from 'react';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;
export const ProductCardContentWrapper = ({ media, ...props }: Props) => {
    return (
        <Layout
            data-testid="product-card-content-wrapper"
            media={{
                initial: {},
                ...media,
            }}
            {...props}
        />
    );
};
